import axios from 'axios';
import {backendHost} from '../../config';

export const putProviders = (params) => {
    return axios.put(`${backendHost}/api/admin/v2/games/providers`, params);
};